import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  scholarlevels: []
}

// getters
export const getters = {
  scholarlevels: state => state.scholarlevels
}

// mutations
export const mutations = {
  [types.FETCH_SCHOLARLEVELS_SUCCESS] (state, { scholarlevels }) {
    state.scholarlevels = scholarlevels
  },

  [types.FETCH_SCHOLARLEVELS_FAILURE] (state) {
    state.scholarlevels = []
  }
}

// actions
export const actions = {
  async fetchScholarlevels ({ commit }) {
    try {
      const response = await axios.get(`/api/scholarlevels`)

      commit(types.FETCH_SCHOLARLEVELS_SUCCESS, { scholarlevels: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_SCHOLARLEVELS_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/scholarlevels.js